/**
 * Name of the non-HttpOnly companion cookie holding the epoch-ms expiry of
 * the current `up-access` HttpOnly auth cookie.
 *
 * Lives in `common` because both sides need the name and the UI
 * intentionally does not cross-import from `@upright/main`:
 * - the backend sets/clears it in `upserve/common/session/auth-cookies.ts`
 *   (see the rationale comment there),
 * - the SPA reads it pre-flight in `ui/api/common/fetcher-core.ts` to
 *   refresh the access token proactively before it expires.
 *
 * The value is just a timestamp — deliberately JS-readable, XSS gains
 * nothing from it.
 */
export const AUTH_ACCESS_EXPIRY_COOKIE_NAME = 'up-access-expiry';
